import { ReactElement } from 'react';
import { GlueConnection } from '@localstack/types';
import { getSchema } from '@localstack/services';
import { Link } from '@mui/material';

import { MagicTable } from '../../../magic/MagicTable';

export type GlueConnectionsTableProps = {
  connections: GlueConnection[];
  selectable?: boolean;
  loading?: boolean;
  onSelect?: (names: string[]) => void;
  onViewConnection?: (name: string) => void;
};

export const GlueConnectionsTable = ({
  connections,
  selectable = true,
  loading,
  onSelect,
  onViewConnection,
}: GlueConnectionsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('Glue')}
    entry="Connection"
    idAttribute="Name"
    rows={connections}
    selectable={selectable}
    onSelect={onSelect}
    loading={loading}
    filterColumns={['Name', 'Description', 'ConnectionType', 'CreationTime', 'LastUpdatedTime']}
    externalFields={{
      Name: (row) => (
        <Link onClick={() => onViewConnection && onViewConnection(row.Name as string)} underline="hover">
          {row.Name}
        </Link>
      ),
    }}
  />
);
